import React from 'react';
import BannerImg from '../../../../public/banners/homepage-banner-v3.png';

export const BannerImageSource = BannerImg;

const BannerImage = (props) => {
  return (
    <img {...props} src={BannerImageSource} alt="Image Banner"/>
  );
};

export default React.memo(BannerImage);